import "@/App.css";
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import TourDetail from "@/pages/TourDetail";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancel from "@/pages/BookingCancel";
import LegalPage from "@/pages/LegalPage";
import Caraguatatuba from "@/pages/Caraguatatuba";
import CostaRica from "@/pages/CostaRica";
import Rivas from "@/pages/Rivas";
import Huacachina from "@/pages/Huacachina";
import Faq from "@/pages/Faq";
import Book from "@/pages/Book";

import Places from "@/pages/Places";

import GalleryPage from "@/pages/GalleryPage";

import Shop from "@/pages/Shop";

import GAListener from "@/components/GAListener";

import Media from "./pages/Media";


function App() {


   useEffect(() => {
    // Block right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Block F12 and common developer shortcut keys
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'C' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'u')
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Clean up the events when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <GAListener />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/brasil" element={<Caraguatatuba />} />
            <Route path="/brazil" element={<Caraguatatuba />} />

            <Route path="/caraguatatuba" element={<Caraguatatuba />} />
            <Route path="/costarica" element={<CostaRica />} />
            <Route path="/cr" element={<CostaRica />} />
            <Route path="/uvita" element={<CostaRica />} />
            <Route path="/dominical" element={<CostaRica />} />
            <Route path="/dominicalito" element={<CostaRica />} />
             <Route path="/dominicalito-dominical" element={<CostaRica />} />
             <Route path="/uvita-whaletail" element={<CostaRica />} />
             
            <Route path="/places_nearby" element={<CostaRica />} />
            <Route path="/outdoor_adventure" element={<CostaRica />} />
            

            <Route path="/rivas-perezzeledon" element={<Rivas />} />
            <Route path="/rivas" element={<Rivas />} />
            <Route path="/perezzeledon" element={<Rivas />} />
            <Route path="/pz" element={<Rivas />} />
            <Route path="/san_jose" element={<Rivas />} />



            <Route path="/huacachina" element={<Huacachina />} />
            <Route path="/peru" element={<Huacachina />} />
            <Route path="/oasis-huacachina-peru" element={<Huacachina />} />


            <Route path="/tours/:tourId" element={<TourDetail />} />
            <Route path="/tandem/:tourId" element={<TourDetail />} />

            <Route path="/booking/success" element={<BookingSuccess />} />
            <Route path="/booking/cancel" element={<BookingCancel />} />
            <Route path="/refund-policy" element={<LegalPage kind="refund" />} />
            <Route path="/privacy-policy" element={<LegalPage kind="privacy" />} />
            
            <Route path="/faq" element={<Faq />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/destinations" element={<Places />} />   
            <Route path="/book" element={<Book />} /> 
            <Route path="/shop" element={<Shop />} />  

            <Route path="/midia" element={<Media />} />  
            <Route path="/media" element={<Media />} />  
            <Route path="/social" element={<Media />} />  
            <Route path="/contact" element={<Media />} />  
            <Route path="/about" element={<Media />} />  



          <Route path="*" element={<Shop />} />
         


            
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
